module.exports = __webpack_public_path__ + "media/images/propresenter-bg-9d3e33cfc55651e651477765792f7d30.jpg";